import Step5 from './Step5'

export default {
  title: 'Results',
  component: Step5,
}
